import React, { Fragment, useContext } from 'react';

import { Select as SelectField } from 'formlabs-web-components/Form';
import { FormContext } from './Form';

const Select = ({ children, label, name, isRequired, value, onChange }) => {
  const { formName, invalidFields } = useContext(FormContext);
  const id = `${formName}_select_${name}`;

  const hasError = invalidFields.includes(name);

  return (
    <Fragment>
      {label ? (
        <label aria-hidden="true" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <SelectField
        name={name}
        id={id}
        required={isRequired}
        hasError={hasError}
        defaultValue={value}
        onChange={onChange}
      >
        {children}
      </SelectField>
    </Fragment>
  );
};

export default Select;

const Option = ({ title, value }) => <option value={value}>{title}</option>;

export { Option };
